import { ValidationStatus } from 'components/ui/validation-item/types';

export interface StatusCheck {
  duplicateCheck?: ValidationStatus;
  duplicateClaimCheck?: ValidationStatus;
}

export const AUTO_NAVIGATE_DELAY = 3;
